import * as React from "react";

const Facebook: React.FC = props => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512" {...props} fill="rgba(0,0,0,0.6)">
            <path d="M400 32H48C21.5 32 0 53.5 0 80v352c0 26.5 21.5 48 48 48h137.2V327.7h-63V256h63v-54.6c0-62.2 37-96.5 93.7-96.5 27.1 0 55.5 4.8 55.5 4.8v61h-31.3c-30.8 0-40.4 19.1-40.4 38.7V256h68.8l-11 71.7h-57.8V480H400c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48z" />
        </svg>
    );
};

export default React.memo(Facebook);
